<template>
  <div class="left-box3">
    <div class="left-title">各年级体测成绩分布</div>
    <div class="echarts">
      <div
        id="month"
        :style="{
          width: '830px',
          height: '274px',
          margin: '0 auto',
        }"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'childScore',
  props: ['healthRateData'],
  data() {
    return {
      echartsData: '',
      option1: '',
    }
  },
  watch: {
    healthRateData: {
      handler: function (newVal) {
        console.log('change???')
        this.option1.xAxis[0].data = newVal.grade
        this.option1.series[0].data = newVal.yxl
        this.option1.series[1].data = newVal.lhl
        this.option1.series[2].data = newVal.jgl
        this.option1.series[3].data = newVal.hgl
        var myChart1 = this.$echarts.init(document.getElementById('month'))
        myChart1.setOption(this.option1)
      },
      deep: true,
    },
  },
  mounted() {
    setTimeout(() => {
      this.drawMonthData()
    }, 2000)
    this.drawMonthData()
    window.onresize = () => {
      return (() => {
        this.drawMonthData()
      })()
    }
  },
  computed: {},
  methods: {
    refreshTest() {
      console.log('refresh???')
      var myChart1 = this.$echarts.init(document.getElementById('month'))
      myChart1.setOption(this.option1)
    },
    drawMonthData() {
      var myChart1 = this.$echarts.init(document.getElementById('month'))
      this.option1 = {
        color: ['#009AFE', '#007A4D', '#DE3831', '#FFB612'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          textStyle: {
            color: '#ffffff', //字体颜色
          },
          data: ['优秀率', '良好率', '及格率', '合格率'],
        },
        toolbox: {
          show: true,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          //   feature: {
          //     mark: { show: true },
          //     dataView: { show: true, readOnly: false },
          //     magicType: { show: true, type: ['line', 'bar', 'stack'] },
          //     restore: { show: true },
          //     saveAsImage: { show: true },
          //   },
        },
        xAxis: [
          {
            type: 'category',
            axisTick: { show: false },
            // data: ['2020级', '2021级', '2022级', '2023级'],
            data: this.healthRateData.grade,
            axisLabel: {
              show: true,
              textStyle: {
                color: '#ffffff',
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: [
          {
            name: '优秀率',
            type: 'bar',
            barGap: 0,
            label: {
              show: true,
              color: '#fff',
              position: 'inside',
              formatter: function (params) {
                return params.value + '%'
              },
            },
            emphasis: {
              focus: 'series',
            },
            data: this.healthRateData.yxl,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#33AEFE' },
                { offset: 1, color: '#009AFE' },
              ]),
            },
          },
          {
            name: '良好率',
            type: 'bar',
            label: {
              show: true,
              color: '#fff',
              position: 'inside',
              formatter: function (params) {
                return params.value + '%'
              },
            },
            emphasis: {
              focus: 'series',
            },
            data: this.healthRateData.lhl,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#339571' },
                { offset: 1, color: '#007A4D' },
              ]),
            },
          },

          {
            name: '及格率',
            type: 'bar',
            label: {
              show: true,
              color: '#fff',
              position: 'inside',
              formatter: function (params) {
                return params.value + '%'
              },
            },
            emphasis: {
              focus: 'series',
            },
            data: this.healthRateData.jgl,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#E8746F' },
                { offset: 1, color: '#E14C46' },
              ]),
            },
          },
          {
            name: '合格率',
            type: 'bar',
            label: {
              show: true,
              color: '#fff',
              position: 'inside',
              formatter: function (params) {
                return params.value + '%'
              },
            },
            emphasis: {
              focus: 'series',
            },
            data: this.healthRateData.hgl,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FFC541' },
                { offset: 1, color: '#FFB612' },
              ]),
            },
          },
        ],
      }
      myChart1.setOption(this.option1)
    },
  },
}
</script>
<style scoped lang="scss">
.left-box3 {
  //   width: calc(100% - 0px);
  width: 800px;
  background: linear-gradient(0deg, rgba(0, 122, 77, 0.1) 80%, rgba(0, 122, 77, 0.1) 100%);
  margin-top: 16px;
  padding-top: 16px;
  //   margin-left: 26px;
}

.left-title {
  font-size: 22px;
  margin-bottom: 8px;
  margin-left: 24px;
}
.echarts {
  //   background: linear-gradient(
  //     0deg,
  //     rgba(0, 122, 77, 0.1) 0%,
  //     rgba(0, 122, 77, 0) 100%
  //   );
  //   //   margin-left: 24px;
  //   height: calc(26vh - 46px);
  //   margin-left: calc(24px - 8%);
  height: 242px;
  //   margin-top: -36px;
}
</style>
